import { get } from '../xhr';


export async function getCountries () {
    return get('/utils/countries', null, 'application/json');
}

export async function getLanguages() {
    return get('/utils/languages', null, 'application/json');
}

export async function getAccounts() {
    return get('/utils/payment-accounts', null, 'application/json');
}
